import React, { useContext , useState } from 'react';
import { appContext } from '../../../../../App';
import axios from 'axios';
import './updateAppointment.css'
import { useEffect } from 'react';

export default function UpdateAppointment({keySearch}) {

  const {appointmentList}=useContext(appContext)
  // console.info(appointmentList)

// const pData=[
//  {
//   serial:1,
//   name:"Mr kutti" , 
//   date:"25-08-21" , 
//   time:"7:20" , 
//   contact:"012587478" ,
//   status:"pending"
 
//  },
//  {
//   serial:2,
//   name:"Mr kutti" , 
//   date:"25-08-21" , 
//   time:"7:20" , 
//   contact:"012587478" ,
//   status:"pending"
 
//  },
//  {
//   serial:3,
//   name:"Mr kutti" , 
//   date:"25-08-21" , 
//   time:"7:20" , 
//   contact:"012587478" ,
//   status:"pending"
  
//  },
//  {
//   serial:1,
//   name:"Mr kutti" , 
//   date:"25-08-21" , 
//   time:"7:20" , 
//   contact:"012587478" ,
//   status:"pending"
 
//  },
//  {
//   serial:2,
//   name:"Mr kutti" , 
//   date:"25-08-21" , 
//   time:"7:20" , 
//   contact:"012587478" ,
//   status:"pending"
 
//  },
//  {
//   serial:3,
//   name:"Mr kutti" , 
//   date:"25-08-21" , 
//   time:"7:20" , 
//   contact:"012587478" ,
//   status:"pending"
  
//  },

// ]

//link https://freefrontend.com/css-tables/#google_vignette

const textDesign={
  fontWeight:'bold',
  fontSize:'16px',
  textAlign:'center',
  textShadow: "2px 3px 2px rgba(0,0,0,0.3),0px 0px 0px rgba(255,255,255,0.3)"
}

const handleColor=(status)=>{
  switch (status) {
    case "Not Visited":
      return {color:'#5C9A67', ...textDesign}
      break;
    case 'Visited':
      return {color:'#0089D2',...textDesign}
      break;
    case 'Cancel':
      return {color:'crimson', ...textDesign}
      break;
  
    default:
      return null
      break;
  }
}





const initialData=appointmentList
const [data, setData] = useState(appointmentList);
const [searchQuery, setSearchQuery] = useState("");

const handleSearch = (event) => {
  const query = event.target.value.toLowerCase();
  setSearchQuery(query);

  const filteredData = initialData.filter((item) => {
    for (const key in item) {
      if (item[key].toString().toLowerCase().includes(query)) {
        return true;
      }
    }
    return false;
  });

  setData(filteredData);
};

// const filteringData= keySearch ?  data.filter(each=>each.email===keySearch) : data

// console.log(data)







 return (
  <section id="update_appointment" className="py-2">   
   <h3>Appointments</h3>
   {/* <h1>Checkbox List with Search... (React)</h1>
      <input
        type="text"
        placeholder="Search"
        value={searchQuery}
        onChange={handleSearch}
      /> */}
   <main>
     <table>
       <thead>
       
         <tr>
         
           {
            appointmentList?.slice(0,1).map((item)=>Object.keys(item).filter(each=>each!=="serial").map((th)=>
            <th key={Math.random()}>
            {th.toLocaleUpperCase()}
            </th> 
            ))
           }      
         </tr>
       </thead>        
       <tbody>  
       {/* {appointmentList.filter(each=>delete each.serial).map((item)=>
          <tr>
          {Object.values(item).map((td,i)=>
           <td data-title={Object.keys(item)[i]} style={handleColor(td)} >
            {td}
          </td>
          ) }       
         </tr>
         )}      */}

         {/* {filteringData.filter(each=>delete each.serial).map((item)=>
          <tr>
          {Object.values(item).map((td,i)=>
           <td data-title={Object.keys(item)[i]} style={handleColor(td)} >
            {td}
          </td>
          ) }       
         </tr>
         )} */}

         {appointmentList.length>0 ?
          data.filter(each=>delete each.serial).map((item)=>
          
          
         
          <tr>
          
          {Object.values(item).map((td,i)=>
            
            
           <td data-title={Object.keys(item)[i]} style={handleColor(td)} >
           
            {td}
          </td>
         
          ) }       
         </tr>
         

         )
         :
         <img src="https://i.pinimg.com/originals/3d/6a/a9/3d6aa9082f3c9e285df9970dc7b762ac.gif" alt="" width="40%"/>
         }


       </tbody>  
     </table>  
   </main>
 </section>
 )
}


